var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouare5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.139 0C17.3343 0.205392 18.4568 0.940827 18.98 2.05723C19.6721 3.53473 19.139 5.82716 19.3078 7.45042C19.1257 8.77884 17.0727 8.78216 16.9304 7.45042C16.8012 6.26114 17.1522 4.39936 16.8674 3.3194C16.7813 2.99143 16.3443 2.43489 15.9966 2.43489H10.1919L10.98 2.80923C11.3972 3.02125 12.0595 3.94551 12.0595 4.38942V22.9443H15.9966C16.0264 22.9443 16.2482 22.8283 16.3045 22.7985C16.6953 22.5865 16.8774 22.2055 16.9237 21.7748C17.0926 20.2079 16.788 18.3726 16.927 16.7958C17.0529 15.3812 19.1059 15.3514 19.3078 16.7427C19.0595 18.7702 19.8774 22.0796 18.7085 23.7923C18.2184 24.5079 16.9999 25.3825 16.1092 25.3825H12.0595V27.0521C12.0595 27.1117 11.8708 27.5755 11.8244 27.6683C11.3078 28.7284 10.1754 29.1789 9.04625 28.9337C6.59261 28.4004 3.92042 27.0289 1.45022 26.3928C0.662145 26.0616 0.178701 25.3493 -0.00341797 24.5311V2.04067C0.244926 0.990519 0.98996 0.245145 2.03963 0H16.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7451 13.314H16.7915C16.7418 13.314 16.4074 13.1848 16.3378 13.1451C15.6491 12.7741 15.4835 11.8134 16.0299 11.2469C16.116 11.1574 16.5862 10.8792 16.6822 10.8792H21.7518V7.05622C21.7518 6.96346 21.9107 6.64212 21.9802 6.54605C22.361 6.0127 23.1789 5.88681 23.6988 6.30091L28.6922 11.2767C29.1557 11.8631 29.0862 12.413 28.6359 12.9761C27.2981 14.6491 25.1855 16.1895 23.7551 17.8393C23.2518 18.2666 22.467 18.2269 22.0398 17.7068C21.9637 17.614 21.7551 17.2297 21.7551 17.1403V13.3174L21.7451 13.314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouare5);
export default __webpack_public_path__ + "static/media/youare5.70f931ed0001d58656b5dfec159fb596.svg";
export { ForwardRef as ReactComponent };